import { render, staticRenderFns } from "./SportsList.vue?vue&type=template&id=2e8999e0&scoped=true&"
import script from "./SportsList.vue?vue&type=script&lang=js&"
export * from "./SportsList.vue?vue&type=script&lang=js&"
import style0 from "./SportsList.vue?vue&type=style&index=0&id=2e8999e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8999e0",
  null
  
)

export default component.exports